import React from "react";

import {
  useAllocateResources,
  useAssignTag,
  useRemoveAllocation,
} from "@planzone/view-models";
import { allocation, Assignable } from "@planzone/dto";
import { ActivityWatcher } from "@common/activityWatcher";
import { TagForm } from "@common/tagForm";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function Forms({
  project,
  allocationMenuState,
  tagMenuState,
  setAllocationMenuState,
  setTagMenuState,
}: Props) {
  const { allocateResources } = useAllocateResources(allocationMenuState.task);
  const { removeAllocation } = useRemoveAllocation({
    ...allocation,
    uuid: "",
  });
  const { isRequestPending: isTagAssignmentRequestPending, assignTag } =
    useAssignTag();

  return (
    <React.Fragment>
      {allocationMenuState.isDisplayed && (
        <ActivityWatcher
          blur={() =>
            setAllocationMenuState({
              ...allocationMenuState,
              isDisplayed: false,
            })
          }
        >
          <div
            className={styles.quickAllocationMenu}
            style={{
              left: allocationMenuState.x + 30,
              top: allocationMenuState.y - 20,
            }}
          >
            <ResourceAllocationMenu
              allocatedResources={[
                ...allocationMenuState.task.allocations.map(
                  (allocation) => allocation.resource,
                ),
              ]}
              select={(resources) => {
                allocateResources({
                  allocations: resources.map((resource) => ({
                    ...allocation,
                    resource,
                  })),
                  task: allocationMenuState.task,
                  project,
                });
              }}
              unSelect={(resources) =>
                resources.forEach(({ uuid }) => {
                  const allocation = allocationMenuState.task.allocations.find(
                    (allocation) => allocation.resource.uuid === uuid,
                  );

                  allocation && removeAllocation(allocation);
                })
              }
            />
          </div>
        </ActivityWatcher>
      )}
      {tagMenuState.isDisplayed && (
        <ActivityWatcher
          blur={() =>
            setTagMenuState({
              ...tagMenuState,
              isDisplayed: false,
            })
          }
        >
          <div
            className={styles.tagMenu}
            style={{
              left: tagMenuState.x + 30,
              top: tagMenuState.y - 20,
            }}
          >
            <TagForm
              filters={tagMenuState.task.tags}
              submit={(tag) => {
                !isTagAssignmentRequestPending &&
                  tag.name.length > 0 &&
                  assignTag({
                    project,
                    assignable: Assignable.TASK,
                    assignableId: tagMenuState.task.uuid,
                    tag,
                  });
                setTagMenuState({
                  ...tagMenuState,
                  isDisplayed: false,
                });
              }}
            />
          </div>
        </ActivityWatcher>
      )}
    </React.Fragment>
  );
}

export { Forms };
